var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(" "+_vm._s(_vm.scalar.title)+" "),_c('feather-icon',{staticClass:"cursor-pointer text-primary",attrs:{"size":"18","icon":"PlusSquareIcon"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }